
const components = new Map()


//registrer all slots
components.set('number', ctx => {
  return {
    key: 'number',
    defaultPlacement: 'basis',
    component: 'ResidentialNumber',
    props: {
      required: true,
      pattern: ctx.$path('project.metadata.residentialNumberPattern', ctx.item)
    },
    slots: {
      below: [{
        component: 'CheckboxComponent',
        key: 'showDisplayName',
        props: {
          label: ctx.$t('useDisplayName'),
          class: 'mt-1'
        },

      }],
    },
  }
})


components.set('status', ctx => {
  return {
    component: 'ResidentialStatus',
    key: 'status',
    defaultPlacement: 'basis',
    props: {
      suffix: status => ctx.getStatusSuffix(status),
    },
    disabled: ctx.bid,
    slots: ctx.bid ? {
      'after-label': [
        {
          component: 'ButtonComponent',
          props: { style: "margin-left: auto; font-weight: normal", label: ctx.$t('pressHereToCancelBid'), tag: 'router-link', to: { name: 'contract', params: { id: ctx.bid.id }, query: { state: 'cancelContract' } } },

        }]

    } : {},
  }
})

components.set('owners', ctx => {
  return {
    component: 'ResidentialOwners',
    key: 'owners',
    defaultPlacement: 'basis',
    disabled: ctx.$path('ownerReservedState.tooltip.content')

  }
})
components.set('reservedBy', ctx => {
  return {
    component: 'ResidentialOwners',
    key: 'reservedBy',
    defaultPlacement: 'basis',
    props: {
      label: ctx.$t('reservedBy'),

    }
  }
})

components.set('sale', ctx => ({
  component: 'ResidentialPrice',
  key: 'sale',
  defaultPlacement: 'basis',

}))

components.set('address', ctx => ({
  component: 'ResidentialAddress',
  key: 'address',
  defaultPlacement: 'basis',
  props: {
    'default-address': ctx.$path('item.project.address'),
    disabled: true,

  }
}))


components.set('properties', ctx => ({
  component: ctx.view === 'residential-update' ? 'ResidentialPropertiesSelect' : 'ResidentialProperties',
  key: 'properties',
  defaultPlacement: 'basis',
  props: {
    model: ctx.view === 'residential-template' ? 'ResidentialTemplate' : 'Residential',
    setDefaultValues: ctx.view === 'residential-template' ? true : false,
    parent: ctx.item,
    type: 'property',
    currency: ctx.$path('project.metadata.currency', ctx.item) || ctx.$path('$store.state.enums.Region.currency', ctx)
  }
}))

components.set('facilities', ctx => {

  return {
    component: ctx.view === 'residential-update' ? 'ResidentialPropertiesSelect' : 'ResidentialProperties',
    key: 'facilities',
    defaultPlacement: 'basis',
    props: {
      //override key, to use properties as value
      key: 'properties',
      type: 'facility',
      model: ctx.view === 'residential-template' ? 'ResidentialTemplate' : 'Residential',
      parent: ctx.item,

    }
  }
})

//fields used on in presentation view
components.set('bid-url', ctx => {
  return {
    component: 'ResidentialBidUrl',
    key: 'bidUrl',
    defaultPlacement: 'presentation',
    props: {
      key: 'sale.bidUrl',
    }
  }
})


export default components
